export default "__VITE_ASSET__BVqR4dY9__"